<template>
  <div class="BasicEduIT">
      <div class="BasicEduIT-part1">
        <div class="container">
          <h1>IT服务</h1>
          <h2>ASM</h2>
          <p class="p1">Apple School Manager 是什么？</p>
          <p class="p2">“Apple 校园教务管理” 是一个简单易用的门户网站，IT 管理团队可以通过它在校内部署 iPad 和 Mac</p>
          <p class="p2">为学生和教职员工提供 Apple 服务权限、完成设备设置、获取和分发应用程序</p>
          <p class="p2">ASM 整合了 DEP、VPP 及管理式 Apple ID</p>

          <div class="item-1">
            <el-row>
              <el-col :xs="24" :sm="24" :md="24" :lg="11" :xl="11">
                <div class="con">
                  <p class="tit">批量购买计划</p>
                  <p class="desc">(Volume Purchase Program)<br>批量购买 App 许可结合 MDM 推送给设备</p>
                  <p class="tit">设备注册计划</p>
                  <p class="desc">(Device Enrollment Program)<br>结合 MDM 自动化地批量注册和部署移动设备</p>
                  <p class="tit">管理式 Apple ID<br>所有账户享有200G 免费 iCloud 空间</p>
                </div>
              </el-col>
              <el-col :xs="24" :sm="24" :md="24" :lg="13" :xl="13">
                <div class="img">
                  <img src="../assets/img/icon-baseIt-1.png" alt="">
                </div>
              </el-col>
            </el-row>
          </div>          
        </div>
      </div>

      <div class="BasicEduIT-part2">
        <div class="container">
          <h1>MDM</h1>
          <p class="p1">Apple 硬件产品和教育相关 APP 软件 ，通过 Mobility Security & Control Solution 来满足教育客户的需求，也为客户打造出真正的未来科技校。</p>
          <div class="item-1">
            <img src="../assets/img/cs-baseIt-1.jpg" alt="">
            <div class="con">
              <div class="middle">
                <p class="p2">为什么使用 Jamf Pro?</p>
                <p class="p3">Apple 设备可以提供最安全的环境和最佳的用户使用体验。<br>而 Jamf Pro 提供最佳的 Apple 设备管理工具。</p>
              </div>
            </div>
            <div style="clear:both"></div>
          </div>

          <!-- 1 -->
          <div class="conRow">
            <div class="conRow-icon">
              <div class="middle"><img src="../assets/img/icon-baseIt-2.png" alt=""></div>
            </div>
            <div class="conRow-desc">
              <p class="p4">快速部署Mac、iPad、 iPhone 和 Apple TV</p>
              <p class="p5">完全结合 Apple 商务管理（ABM），IT 无需对设备操作，即可将大量设备同时完成部署和合规配置。</p>
            </div>
            <div style="clear:both"></div>
          </div>

          <!-- 2 -->
          <div class="conRow">
            <div class="conRow-icon">
              <div class="middle"><img src="../assets/img/icon-baseIt-3.png" alt=""></div>
            </div>
            <div class="conRow-desc">
              <p class="p4">收集动态库存</p>
              <p class="p5">建立条件式的动态群组，即时掌握硬件状态和软件配置，有效进行计划和预算制定。</p>
            </div>
            <div style="clear:both"></div>
          </div>

          <!-- 3 -->
          <div class="conRow">
            <div class="conRow-icon">
              <div class="middle"><img src="../assets/img/icon-baseIt-4.png" alt=""></div>
            </div>
            <div class="conRow-desc">
              <p class="p4">降低风险并保护资源</p>
              <p class="p5">完全髮揮 Apple 內置在每台設備的世界級安全工具。與設備核心互動，安全穩定。</p>
            </div>
            <div style="clear:both"></div>
          </div>

          <!-- 4 -->
          <div class="conRow">
            <div class="conRow-icon">
              <div class="middle" style="height: 113px;"><img src="../assets/img/icon-baseIt-5.png" alt=""></div>
            </div>
            <div class="conRow-desc">
              <p class="p4">建立企业 IT 生态系统</p>
              <p class="p5">与环境中的第三方工具进行自动化 API 接口、云端分发，同时进行域整合。</p>
            </div>
            <div style="clear:both"></div>
          </div>

          <!-- 5 -->
          <div class="conRow">
            <div class="conRow-icon">
              <div class="middle" style="height: 189px;"><img src="../assets/img/icon-baseIt-6.png" alt=""></div>
            </div>
            <div class="conRow-desc">
              <p class="p4">帮助用户做到更多（这样您需要做的就更少）</p>
              <p class="p5">我们专有的自助服务区（SELF SERⅥCE）让使用者可以依需求，一站式的取得企业允许安装的应用程序、软件和内容。同时在不打扰 IT 的情形下套用系统配置和进行定期的设备维护。</p>
            </div>
            <div style="clear:both"></div>
          </div>

          <!-- 6 -->
          <div class="conRow">
            <div class="conRow-icon">
              <div class="middle" style="height: 113px;"><img src="../assets/img/icon-baseIt-7.png" alt=""></div>
            </div>
            <div class="conRow-desc">
              <p class="p4">轻松应对任何紧急时刻</p>
              <p class="p5">通过远程锁定和擦除，自动修补程序以及报告备份状态来确保您高枕无忧。</p>
            </div>
            <div style="clear:both"></div>
          </div>

          <div class="item-2">
            <h3>VMWARE WORKSPACE ONE</h3>
            <h4>易于使用、企业级安全性。</h4>
            <p class="gk">概览</p>
            <p class="gkcon">VMware® Workspace ONEＴM 是一款智能驱动型数字化工作空间平台，可通过集成访问控制、应用管理和多平台端点管理来简单、安全地在任意设备上交付和管理任何应用。它既可以作为云服务以包年方式使用，也提供永久形式的本地部署许可证。</p>
            <p class="gkcon">Workspace ONE 基于 VMware AirWatch® Unified Endpoint ManagementTM 技术而构建，并与通用身份认证框架上的虚拟应用交付解决方案 ( VMware Horizon®) 相集成。借助 Workspace ONE ，企业现在可以改进孤立的云计算和移动投资，使所有员工、设备及整个企业内的一切都能够采用基于平台的方案来加速其数字化转型之旅。</p>
            <img src="../assets/img/cs-baseIt-2.jpg" alt="">
          </div>
        </div>
      </div>

      <div class="cs-page">
        <router-link to="home" active-class="activeClass">首页</router-link>
        <router-link to="BasicEduParents" active-class="activeClass">上一页</router-link>
        <router-link to="BasicEduSolution" active-class="activeClass">下一页</router-link>
      </div>
  </div>
</template>
<script>
export default {
  name:'BasicEduIT',
  data() {
    return {
    }
  },
  mounted(){
  },
  methods: {
    
  }
}
</script>
<style lang="scss">
.BasicEduIT{
   border-bottom: 1px solid #D6D6D6;
   .BasicEduIT-part1{
     h1{
        font-size: 58px;
        font-weight: 600;
        color: #000000;
        line-height: 76px;
        text-align: center;
        padding: 115px 0 69px 0;
     }
     h2{
        font-size: 42px;
        font-weight: 600;
        color: #000000;
        line-height: 38px;
        text-align: center;
     }
     .p1{
        font-size: 24px;
        font-weight: bold;
        line-height: 38px;
        color: #0071E3;
        text-align: center;
        margin: 34px 0 5px 0;
     }
     .p2{
        font-size: 20px;
        font-weight: 400;
        color: #000;
        text-align: center;
        line-height: 38px;
     }
     .item-1{
       margin: 107px 0 106px 0;
       .con{
          .tit{
              font-size: 32px;
              font-weight: 400;
              color: #000000;
          }
          .desc{
            font-size: 24px;
              font-weight: 400;
              color: #333333;
              margin-bottom: 45px;
          }
        }
        img{
          margin-top: 25px;
          margin-left: 35px;
          max-width: 100%;
        }
     }
     
   }
   .BasicEduIT-part2{
     background: #fff;
     h1{
      font-size: 42px;
      font-weight: 600;
      color: #000000;
      line-height: 38px;
      text-align: center;
      padding: 83px 0 45px 0;
     }
     .p1{
        font-size: 24px;
        font-weight: 400;
        color: #000000;
        line-height: 38px;
        text-align: center;
        max-width: 861px;
        margin: 0 auto 65px auto;
     }
     .item-1{
       min-height: 600px;
       position: relative;
       margin-bottom: 101px;
       img{
          max-height: 100%;
       }
       .con{
         position: absolute;
         top: 0;
         left: 100px;
         height: 500px;
         .middle{
           display: table-cell;
           vertical-align: middle;
           height: 500px;
           .p2{
              height: 84px;
              width: 480px;
              background: #5CB195;
              font-size: 36px;
              font-weight: 600;
              line-height: 84px;
              color: #FFFFFF;
              text-align: center;
           }
           .p3{
              margin-top: 18px;
              padding: 20px 237px 20px 58px;
              font-size: 24px;
              font-weight: 400;
              color: #FFFFFF;
              line-height: 40px; 
              background: #5CB195;     
           }
         }
       }
     }
     .conRow{
       max-width: 960px;
       margin: 0 auto;
       padding-bottom: 60px;
       .conRow-icon{
         float: left;
         width: 10%;
         text-align: center;
         .middle{
           display: table-cell;
           vertical-align: middle;
           height: 151px;
         }
       }
       .conRow-desc{
         float: left;
         width: 85%;
         margin-left: 5%;
         text-align: left;
         .p4{
            font-size: 32px;
            font-weight: 600;
            color: #000000;
            text-align: left;
            margin-bottom: 30px;
         }
         .p5{
           font-size: 24px;
            font-weight: 400;
            color: #000000;
            line-height: 38px;
            text-align: justify;
         }
       }
     }
     .item-2{
       text-align: center;
       h3{
          font-size: 36px;
          font-weight: 600;
          color: #000000;
          text-align: center;
          margin: 52px 0 33px 0;
       }
       h4{
          font-size: 26px;
          font-weight: 400;
          color: #333333;
          text-align: center;
       }
       .gk{
          font-size: 24px;
          font-weight: 600;
          color: #0071E3;
          text-align: center;
          margin: 41px 0 47px 0;
       }
       .gkcon{
          font-size: 24px;
          font-weight: 400;
          color: #000000;
          line-height: 38px;
          padding-bottom: 50px;
          max-width: 965px;
          margin: 0 auto;
          text-align: justify;
       }
       img{
         margin: 25px 0 80px 0;
         max-width: 100%;
       }
     }
   }
}
// 适配
@media screen and (max-width: 1045px) {
  .BasicEduIT .BasicEduIT-part1 .item-1 .con .tit,
  .BasicEduIT .BasicEduIT-part1 .item-1 .con .desc,
  .BasicEduIT .BasicEduIT-part1 .item-1 .img{
    text-align: center;
  }
}
// 适配
@media screen and (max-width: 768px) {
  .BasicEduIT{
    .BasicEduIT-part2{
      .p1{
        width: auto;
      }
      .item-1{
        height: 500px;
        img{
          max-height: 100%;
          max-width: none;
        }
        .con{
          left: 50px;
          .middle{
            height: 500px;
            .p2,.p3{
              width: auto;
              padding: 0 15px;
            }
            .p3{
              padding: 10px 15px;
              text-align: justify;
            }
          }
        }
      }
      .conRow{
        width: 100%;
        .conRow-icon{
          width: 20%;
          .middle{
            img{
              max-width: 100%;
            }
          }
        }
        .conRow-desc{
          width: 75%;
          margin-left: 5%;
        }
      }
      .item-2{
        h3{
          font-size: 30px;
        }
        .gkcon{
          width: auto;
        }
      }
    }
  }
}
</style>
